import { useDispatch } from "react-redux";
import { setUpcomingMovies } from "../utils/store/slice/movieSlice";
import { TMDBOptions } from "../utils/tmdbOption";
import { useEffect } from "react";

const UseUpcomingMovies = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    fetch(
      `https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1`,
      TMDBOptions
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setUpcomingMovies(data.results));
      });
  };
};

export default UseUpcomingMovies;
